import React, { Component } from "react";

import { HEADER_COPY, BODY_COPY } from "../../../utils/content-keys";
import "./question.scss";

class Question extends Component {
  state = { open: false };

  toggleOpen = () => {
    this.setState(state => {
      state.open = !state.open;
      return state;
    });
  };

    parseLinks(input) {
        // cms horizon links are actual asset links so parse the markdown
        return input.replace(
            /\[([^\]]+)]\(https:\/\/cms.diageohorizon.com\/([^\)]+)\)/g,
            '<a href="https://cms.diageohorizon.com/$2" class="ArticleTabs__content-copy--link" target="_blank">$1</a>'
        ).replace(
          /\[([^\]]+)]\(https:\/\/www.google.co.uk\/([^\)]+)\)/g,
          '<a href="https://www.google.co.uk/$2" class="ArticleTabs__content-copy--link" target="_blank">$1</a>'
      );
    }

  render() {
    const { question } = this.props;

    return (
      <div className={`question ${this.state.open ? "question--open" : ""}`}>
        <h3 role="heading" aria-level="2" className="question__question" onClick={this.toggleOpen}>
          {question[HEADER_COPY].value}
        </h3>
        <p className="question__answer" dangerouslySetInnerHTML={{__html: this.parseLinks(question[BODY_COPY].value)}}></p>
      </div>
    );
  }
}

export default Question;



// WEBPACK FOOTER //
// ./src/pages/faqs/Question/index.js